import React from 'react';
import ReactDOM from 'react-dom';
import MetricKeyResultsComp from './components/kr-results.component';

function RenderMetricKeyResultsComp(data, elementId) {
  // console.log('RenderMetricKeyResultsComp');
  // console.log(data);
  let mountId;
  if (elementId) {
    mountId = document.getElementById(elementId);
  } else {
    mountId = document.getElementById('metric-result-details-1');
  }
  if (mountId) {
    // console.log('mounted');
    ReactDOM.render(<MetricKeyResultsComp data={data} />, mountId);
  }
}

window.RenderMetricKeyResultsComp = RenderMetricKeyResultsComp;
